const stages = {
  PREALPHA: 0,
  ALPHA: 1,
  BETA: 2,
  STABLE: 3,
};
export default stages;
